import { Grid, Spin } from "antd";
import { useEffect, useLayoutEffect, useState } from "react";
import {
  ChurnRate,
  SubscriptionRenewalRate,
  SubscriptionRetentionRate,
  TotalUsers,
  UsersWithExpiredSubscription,
  UsersWithSubscription,
  UsersWithTrial,
} from "./components";
import { ConditionalRenderer } from "components";
import { UseLazyApiCallInternalDashboard } from "pages/internal-dashboard/hooks/use-lazy-api-call";
import { calculateContainerProperties } from "./helpers";
import styles from "./styles.module.scss";

const { useBreakpoint } = Grid;

export function KeyMetrics({
  activeSportType,
  activePlateform,
  activeFeature,
}: any) {
  const screens = useBreakpoint();

  const [gridProperties, setGridProperties] = useState({
    maxHeight: 0,
    gap: 0,
    height: 0,
  });

  const [fetchKeyMetrics, { data, isLoading }]: any =
    UseLazyApiCallInternalDashboard({
      // function should be used to get the url based on sport type
      url: "count/keyMetrics",
      method: "POST",
      body: {
        platform: activePlateform === "desktop" ? "studio" : activePlateform,
        feature: activeFeature,
      },
    });

  useEffect(() => {
    if (activeSportType === "golf") {
      fetchKeyMetrics();
    }
  }, [activeSportType, activePlateform, activeFeature]);

  useEffect(() => {
    function handleGridContainer() {
      const { top = 0, width = 0 }: Partial<DOMRect> =
        document.getElementById("key-metrics")?.getBoundingClientRect() || {};

      setGridProperties(calculateContainerProperties({ top, width, screens }));
    }

    handleGridContainer();
    window.addEventListener("resize", handleGridContainer);
    return () => window.removeEventListener("resize", handleGridContainer);
  }, [screens]);

  return (
    <div
      id="key-metrics"
      className={styles.keyMetricsContainer}
      style={{
        height: screens?.lg ? gridProperties?.maxHeight + "px" : "auto",
        gap: gridProperties?.gap + "px",
      }}
    >
      <div
        className={styles.keyMetricsGrid1}
        style={{
          height: gridProperties?.height + "px",
          gap: gridProperties?.gap + "px",
        }}
      >
        {gridProperties?.height ? (
          <>
            <ConditionalRenderer condition={activeSportType === "golf"}>
              <TotalUsers data={data?.data?.registered} isLoading={isLoading} />

              <UsersWithSubscription
                data={data?.data?.paid}
                isLoading={isLoading}
              />

              <UsersWithTrial data={data?.data?.trial} isLoading={isLoading} />

              <UsersWithExpiredSubscription
                data={data?.data?.expired}
                isLoading={isLoading}
              />
            </ConditionalRenderer>
            <ConditionalRenderer condition={activeSportType === "baseball"}>
              <TotalUsers data={{}} isLoading={isLoading} />

              <UsersWithSubscription data={{}} isLoading={isLoading} />

              <UsersWithTrial data={{}} isLoading={isLoading} />

              <UsersWithExpiredSubscription data={{}} isLoading={isLoading} />
            </ConditionalRenderer>
            <ConditionalRenderer condition={activeSportType === "athletics"}>
              <TotalUsers data={{}} isLoading={isLoading} />

              <UsersWithSubscription data={{}} isLoading={isLoading} />

              <UsersWithTrial data={{}} isLoading={isLoading} />

              <UsersWithExpiredSubscription data={{}} isLoading={isLoading} />
            </ConditionalRenderer>
          </>
        ) : (
          <div className={styles.loading}>
            <Spin />
          </div>
        )}
      </div>
      <div
        className={styles.keyMetricsGrid2}
        style={{
          height: gridProperties?.height + "px",
          gap: gridProperties?.gap + "px",
        }}
      >
        {gridProperties?.height ? (
          <>
            <ConditionalRenderer condition={activeSportType === "golf"}>
              <SubscriptionRenewalRate
                data={data?.data?.renewal}
                isLoading={isLoading}
                totalUsers={data?.data?.registered}
              />

              <SubscriptionRetentionRate
                data={data?.data?.retention}
                isLoading={isLoading}
                totalUsers={data?.data?.registered}
              />

              <ChurnRate
                data={data?.data?.churned}
                isLoading={isLoading}
                totalUsers={data?.data?.registered}
              />
            </ConditionalRenderer>
            <ConditionalRenderer condition={activeSportType === "baseball"}>
              <SubscriptionRenewalRate />

              <SubscriptionRetentionRate />

              <ChurnRate />
            </ConditionalRenderer>
            <ConditionalRenderer condition={activeSportType === "athletics"}>
              <SubscriptionRenewalRate />

              <SubscriptionRetentionRate />

              <ChurnRate />
            </ConditionalRenderer>
          </>
        ) : (
          ""
        )}
      </div>
    </div>
  );
}
